import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { State as AccessTokenState } from '~/AccessToken';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { State as CzReimbursementState, Update } from '~/CzReimbursement/reducer';
import { Status, Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface State {
	accessToken: AccessTokenState;
	czReimbursement: CzReimbursementState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (!update || update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Statuses.saving;
		case 'updated':
			return Statuses.saved;
		case 'failed':
			return Statuses.failed;
		default:
			return null;
	}
});

function mapStateToProps({ czReimbursement }: State, { group }: OwnProps): { updateStatus: Status | null } {
	return {
		updateStatus: selectUpdateStatus(group.id, czReimbursement.update),
	};
}

export default connect(mapStateToProps)(ParametersPanel);
